import { useState } from 'react';

export const useModal = (openDefault = false): any => {
	const [isOpen, setIsOpen] = useState<boolean>(openDefault);

	const handleOpen = () => setIsOpen(true);
	const handleClose = () => setIsOpen(false);

	return [isOpen, handleOpen, handleClose];
};
